import { CloseOutlined } from "@ant-design/icons";
import { Popconfirm, PopconfirmProps } from "antd";
import {
  ReactElement,
  ReactNode,
  cloneElement,
  isValidElement,
  useState,
} from "react";
import styles from "./index.module.css";

type IProps = PopconfirmProps & {
  skipConfirm?: boolean;
};

export function Confirm(props: IProps) {
  const {
    title,
    children,
    open: controlledOpen,
    onOpenChange: onOpenChangeProp,
    skipConfirm,
    onConfirm,
    ...rest
  } = props;
  const [internalOpen, setInternalOpen] = useState(false);

  const mergedOpen = controlledOpen ?? internalOpen;

  const onOpenChange = (nextOpen: boolean) => {
    onOpenChangeProp?.(nextOpen);

    if (!nextOpen) {
      setInternalOpen(nextOpen);
      return;
    }

    if (skipConfirm) {
      onConfirm?.();
    } else {
      setInternalOpen(nextOpen);
    }
  };

  return (
    <Popconfirm
      open={mergedOpen}
      placement="topRight"
      onOpenChange={onOpenChange}
      classNames={{
        body: styles.body,
      }}
      arrow={false}
      icon={null}
      title={
        <>
          <div>{title as ReactNode}</div>
          <CloseOutlined
            className="text-[12px] text-white cursor-pointer absolute top-5 right-5"
            onClick={() => onOpenChange(false)}
          />
        </>
      }
      showCancel={false}
      okButtonProps={{
        className: "!px-[24px] !h-[40px] !font-medium",
      }}
      okText="Continue"
      onConfirm={onConfirm}
      {...rest}
    >
      {(() => {
        if (isValidElement(children)) {
          const childElement = children as ReactElement<{ disabled?: boolean }>;
          const originalDisabled = childElement.props?.disabled;
          return cloneElement(childElement, {
            disabled: Boolean(mergedOpen || originalDisabled),
          });
        }
        return children as ReactNode;
      })()}
    </Popconfirm>
  );
}
